(function () {
  'use strict';

  angular.module('app').component('addonList', addonList());

  function addonList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        loadingItems: '<',
        onShowItem: '&',
        onDeletedItem: '&',
        features: '=',
      },
      controller: AddonListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/addons/addon-list/addon-list.component.html',
    };
  }

  AddonListCtrl.$inject = ['UtilService', 'AddonService'];

  function AddonListCtrl(UtilService, AddonService) {
    var vm = this;

    vm.permissions = {
      canShow: true,
      canUpdate: true,
      canDestroy: true,
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = AddonService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.changeItemStatus = changeItemStatus;
    vm.deleteItem = deleteItem;
    vm.onUpdateItems = onUpdateItems;

    vm.groupByFeatureCategory = groupByFeatureCategory;
    vm.selectCheckBoxes = selectCheckBoxes;

    function fetchResult() {
      vm.loadingItems = true;
      AddonService.getAddons(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = AddonService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      AddonService.deleteAddon(item, fetchResult);
    }

    function changeItemStatus(item) {
      AddonService.changeAddonStatus(item);
    }

    function onUpdateItems(action) {
      var successCallback = function () {
        vm.showActions = false;
        vm.selectedAll = false;

        if (action === 'destroy') {
          fetchResult();
        }
      };

      AddonService.updateAddons(action, vm.items, successCallback);
    }

    // Group by feature category
    function groupByFeatureCategory(item) {
      if (item.id) {
        return item.feature_category.name;
      }
    }

    function selectCheckBoxes() {
      vm.UtilService.selectCheckBoxes();
      if (vm.selectedAll) {
        vm.totalItemsSelected = vm.meta.totalItems;
      } else {
        vm.totalItemsSelected = 0;
      }
    }
  }
})();
